var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 44 40",
    fill: "",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6761 32.8648C28.9363 34.9945 25.9199 36.9397 23.6219 38.0887L22 38.8997L20.3782 38.0887C17.4549 36.6271 13.3693 33.8771 10.1692 31.0981C4.06594 25.7979 0.786621 20.3122 0.786621 14.6202C0.786621 10.9514 2.03249 7.69939 4.14079 5.32949L1.45293 2.64164L4.09457 0L41.4529 37.3584L38.8113 40L31.6761 32.8648ZM6.78888 7.97758C5.3616 9.66003 4.52246 11.9662 4.52246 14.6202C4.52246 19.0483 7.25505 23.6194 12.6187 28.2774C15.5667 30.8375 19.3626 33.396 22 34.7228C23.9699 33.7318 26.586 32.0537 29.0124 30.2011L6.78888 7.97758ZM37.1838 27.8591L34.5396 25.2149C37.8156 21.6141 39.4776 18.0737 39.4776 14.6202C39.4776 9.15818 35.7678 5.07655 30.8005 5.05667C28.5349 5.05665 27.2763 5.28125 25.7818 5.98755C24.8639 6.42136 24.051 7.00597 23.3437 7.74703L22.0039 9.15072L20.6523 7.75848C19.9604 7.04587 19.1594 6.47431 18.2516 6.0408C17.02 5.45265 15.9149 5.17556 14.4131 5.08835L10.8596 1.53486C11.6143 1.39408 12.3982 1.32082 13.2066 1.32082C15.8889 1.32082 17.7683 1.67 19.8615 2.66966C20.6163 3.03009 21.3242 3.46023 21.9812 3.95901C22.6635 3.43143 23.3997 2.98133 24.1855 2.60994C26.2384 1.6397 28.0254 1.32081 30.8079 1.32085C37.9202 1.34929 43.2134 7.17307 43.2134 14.6202C43.2134 19.1609 41.1265 23.5704 37.1838 27.8591Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossHeart);
export default __webpack_public_path__ + "static/media/crossHeart.aa2558c9a99f28d5068959c2ee25ab47.svg";
export { ForwardRef as ReactComponent };